/**
 * 売却お問い合わせ：物件種別に応じた面積フィールド表示切替
 *
 * 戸建（used_house）: 土地面積・建物面積
 * マンション（used_mansion）: 専有面積
 * 土地（land）: 土地面積
 */
const AREA_VISIBILITY_MAP = {
    used_house: ['land_area', 'building_area'],
    used_mansion: ['exclusive_area'],
    land: ['land_area'],
};

function toggleAreaBlocks(estateType) {
    const container = document.getElementById('js-sale-area');
    if (!container) return;

    const visibleTypes = AREA_VISIBILITY_MAP[estateType] ?? [];
    const blocks = container.querySelectorAll('[data-area-type]');

    blocks.forEach((block) => {
        const isVisible = visibleTypes.includes(block.dataset.areaType);
        block.style.display = isVisible ? '' : 'none';

        // 非表示のフィールドは値をクリア
        if (!isVisible) {
            block.querySelectorAll('input').forEach((input) => {
                input.value = '';
            });
        }
    });
}

function main() {
    const page = document.getElementById('page-sale');
    if (!page) return;

    const radios = document.querySelectorAll('input[name="estate_type"]');
    if (!radios.length) return;

    radios.forEach((radio) => {
        radio.addEventListener('change', (e) => {
            toggleAreaBlocks(e.target.value);
        });
    });

    // 初期表示（選択済みの場合 or 未選択なら全非表示）
    const checked = document.querySelector('input[name="estate_type"]:checked');
    toggleAreaBlocks(checked?.value ?? '');
}

export default main;
